import { render } from "./listNew.vue?vue&type=template&id=0ba78cde&scoped=true"
import script from "./listNew.vue?vue&type=script&lang=js"
export * from "./listNew.vue?vue&type=script&lang=js"

import "./listNew.vue?vue&type=style&index=0&id=0ba78cde&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba78cde"]])

export default __exports__